// import React from "react";
// import { useNavigate } from "react-router-dom";
// import logo from "../../../src/Assets/Images/yostel.png";
// import { FaFacebook, FaTwitter, FaInstagram, FaYoutube, FaPinterest, FaEnvelope } from 'react-icons/fa';
// import foo1 from '../../Assets/UserSide/foo1.png';
// import foo2 from '../../Assets/UserSide/foo2.png';
// import foo3 from '../../Assets/UserSide/foo3.png';
// import foo4 from '../../Assets/UserSide/foo4.png';
// import foo5 from '../../Assets/UserSide/foo5.png';

// const UserFooter = () => {
//   const navigate = useNavigate();
//   const currentYear = new Date().getFullYear();

//   const handleNavigation = (path) => {
//     navigate(path);
//     window.scrollTo(0, 0);
//   };

//   return (
//     <React.Fragment>
//       <footer className="bg-[#003366] text-white py-12">
//         <div className="md:mx-16 mx-6 px-4">
//           <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
//             {/* Logo and Description Section */}
//             <div className="md:col-span-4">
//               <div className="flex items-center mb-4">
//                 <img src={logo} alt="logo" />
//               </div>
//               <p className="text-sm text-gray-300 mb-6">
//                 Yostel is designed to simplify the experience for both travelers and hostel management.
//                 For guests, it offers easy booking, real-time availability, and seamless check-in/check-out options.
//               </p>
//             </div>

//             {/* Quick Links Section */}
//             <div className="md:col-span-2">
//               <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
//               <ul className="space-y-2">
//                 <li><span onClick={() => handleNavigation("/")} className="text-gray-300 hover:text-white">Home</span></li>
//                 <li><span onClick={() => handleNavigation("/about")} className="text-gray-300 hover:text-white">About</span></li>
//                 <li><span onClick={() => handleNavigation("/services")} className="text-gray-300 hover:text-white">Services</span></li>
//               </ul>
//             </div>

//             {/* Legal Links Section */}
//             <div className="md:col-span-2">
//               <ul className="space-y-2 mt-6 md:mt-0">
//                 <li><a href="/terms" className="text-gray-300 hover:text-white">Terms & Conditions</a></li>
//                 <li><a href="/privacy" className="text-gray-300 hover:text-white">Privacy Policy</a></li>
//                 <li><a href="/refund" className="text-gray-300 hover:text-white">Refund</a></li>
//               </ul>
//             </div>

//             {/* Contact Section */}
//             <div className="md:col-span-4">
//               <div className="flex justify-center md:justify-end mb-6 ">
//                 <div className="flex items-center bg-red-500 rounded-lg px-4 py-2">
//                   <span className="mr-2">+91 895 658 5458</span>
//                   <button className="text-white hover:underline">Let's Talk</button>
//                 </div>
//               </div>

//               <div className="space-y-4">
//                 <div className="flex items-center">
//                   <FaEnvelope className="w-5 h-5 mr-2" />
//                   <span>Infohostel@Gmail.Com</span>
//                 </div>
//                 <div className="relative">
//                   <input
//                     type="email"
//                     placeholder="Enter Your Email"
//                     className="bg-transparent border border-gray-600 rounded-full py-2 px-4 w-full text-white placeholder:text-gray-400"
//                   />
//                   <button
//                     className="absolute right-1 top-1 bg-white text-black rounded-full p-2 hover:bg-gray-200"
//                   >
//                     <FaEnvelope className="w-4 h-4" />
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="flex flex-col md:flex-row justify-between items-center mt-8">
//             {/* Amenities Icons */}
//             <div className="flex justify-center space-x-4 mb-6 md:mb-0">
//               {[foo1, foo2, foo3, foo4, foo5].map((img, index) => (
//                 <img key={index} src={img} alt={`amenity-${index}`} className="w-10 h-10 md:h-auto md:w-auto gap-10" />
//               ))}
//             </div>

//             {/* Social Media Icons */}
//             <div className="flex justify-center space-x-6">
//               <a href="https://facebook.com" className="text-gray-300 hover:text-white">
//                 <FaFacebook className="w-6 h-6" />
//               </a>
//               <a href="https://twitter.com" className="text-gray-300 hover:text-white">
//                 <FaTwitter className="w-6 h-6" />
//               </a>
//               <a href="https://instagram.com" className="text-gray-300 hover:text-white">
//                 <FaInstagram className="w-6 h-6" />
//               </a>
//               <a href="https://youtube.com" className="text-gray-300 hover:text-white">
//                 <FaYoutube className="w-6 h-6" />
//               </a>
//               <a href="https://pinterest.com" className="text-gray-300 hover:text-white">
//                 <FaPinterest className="w-6 h-6" />
//               </a>
//             </div>
//           </div>
//         </div>
//       </footer>

//       <div className=" bg-gradient-to-r from-[#00C5C8] to-[#235784] md:px-16 px-6 py-2 text-white">
//         <div className="flex flex-wrap justify-between items-center">
//           <p className="text-center">© {currentYear} Yostel  All Rights Reserved</p>
//           <p className="text-center">
//             Design & Developed by{' '}
//             <a
//               href="https://www.webbocket.com/"
//               target="_blank"
//               rel="noopener noreferrer"                        >
//               WEB_BOCKET
//             </a>
//           </p>
//         </div>
//       </div>
//     </React.Fragment>
//   );
// };

// export default UserFooter;

import React from "react";
import { useNavigate } from "react-router-dom";
import yostelLog from "../../../src/Assets/Logos/footerYostelLogo.svg";
import foo1 from "../../Assets/Images/JayadevVihar.png";
import foo2 from "../../Assets/Images/Patia.png";
import foo3 from "../../Assets/Images/SahidNagar.png";
import foo4 from "../../Assets/Images/Nayapali.png";
import foo5 from "../../Assets/Images/KitSquare.png";
import foo6 from "../../Assets/Logos/footerMessage.svg";
import foo7 from "../../Assets/Logos/footerCaller.svg";

const UserFooter = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  const slugify = (str) =>
    str
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]+/g, "");

  return (
    <React.Fragment>
      <footer className="bg-[#0B002A] text-white py-12">
        <div className="md:mx-16 mx-6 ">
          <div className="grid grid-cols-1 xl:grid-cols-4 md:grid-cols-2 xl:gap-10 sm:gap-5">
            <div className="tracking-wide">
              <div className=" mb-4">
                <img src={yostelLog} alt="Yostel Logo" className="" />
              </div>
              <p className="text-gray-300 text-sm mb-4 xl:w-[95%] w-full">
                Yostel: Where Wi-Fi’s strong, vibes are stronger, chores vanish,
                and community feels like family. Move in, glow up, and call it
                your second home!
              </p>
              <p className="flex items-center gap-2 text-gray-300 text-sm pb-2">
                <img
                  src={foo6}
                  alt="calling"
                  className="object-cover h-5 w-5"
                />
                <a
                  href="mailto:hello.Yostel@Gmail.Com"
                  className="hover:text-blue-400"
                >
                  hello.yostel@gmail.Com
                </a>
              </p>
              <p className="flex items-center gap-2 text-gray-300 text-sm">
                <img
                  src={foo7}
                  alt="calling"
                  className="object-cover h-5 w-5"
                />
                <a href="tel:+918328991641" className="hover:text-blue-400">
                  +91 83289 91641
                </a>
              </p>
            </div>
            <div className="tracking-wide">
              <h3 className="text-lg font-semibold mb-3 mt-10 ">Quick Links</h3>
              <ul className="space-y-2 text-gray-300 text-sm">
                <li
                  onClick={() => navigate("/")}
                  className="hover:text-blue-400 cursor-pointer"
                >
                  Home
                </li>
                <li
                  onClick={() => navigate("/how-it-works")}
                  className="hover:text-blue-400 cursor-pointer"
                >
                  How it works?
                </li>
                <li
                  onClick={() => navigate("/property-page")}
                  className="hover:text-blue-400 cursor-pointer"
                >
                  Explore Accommodation
                </li>
                <li
                  onClick={() => navigate("/about")}
                  className="hover:text-blue-400 cursor-pointer"
                >
                  About Us
                </li>
                <li className="hover:text-blue-400 cursor-pointer">
                  Contact Us
                </li>
              </ul>
            </div>
            <div className="tracking-wide">
              <h3 className="text-lg font-semibold mb-3 mt-10 ">Others</h3>
              <ul className="space-y-2 text-gray-300 text-sm">
                <li
                  className="hover:text-blue-400 cursor-pointer"
                  onClick={() => navigate("/term-condition")}
                >
                  Terms & Conditions
                </li>
                <li
                  className="hover:text-blue-400 cursor-pointer"
                  onClick={() => navigate("/privacy-policy")}
                >
                  Privacy Policy
                </li>
                <li
                  onClick={() => navigate("/housing-rule")}
                  className="hover:text-blue-400 cursor-pointer"
                >
                  Housing Rule
                </li>
                {/* <li className="hover:text-blue-400">Refund</li> */}
              </ul>
            </div>
            <div className="tracking-wide">
              <h3 className="text-lg font-semibold mb-3 mt-10">Properties</h3>
              <div className="flex flex-wrap gap-4 xl:w-[80%] w-full">
                {[
                  { name: "Shahid Nagar", img: foo3 },
                  { name: "Nayapali", img: foo4 },
                  { name: "KIIT Square", img: foo5 },
                  { name: "Jaydev Vihar", img: foo1 },
                  { name: "Patia", img: foo2 },
                ].map((property, index) => (
                  <div
                    key={index}
                    className="flex flex-col items-center"
                    onClick={() => navigate(`/${slugify(property.name)}`)}
                  >
                    <img
                      src={property.img}
                      alt={property.name}
                      className="w-14 h-14 rounded-full border-2 border-gray-400"
                    />
                    <p className="text-xs text-gray-300 mt-2">
                      {property.name}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </footer>

      <div className=" bg-gradient-to-r from-[#00C5C8] to-[#235784] md:px-16 px-6 py-2 text-white">
        <div className="flex flex-wrap justify-between items-center">
          <p className="text-center">
            © {currentYear} Yostel All Rights Reserved
          </p>
          <p className="text-center">
            Design & Developed by{" "}
            <a
              href="https://www.webbocket.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              WEB_BOCKET
            </a>
          </p>
        </div>
      </div>
    </React.Fragment>
  );
};

export default UserFooter;
